<div class="g-layout__container">
    <div class="pt-8">

        <div
            class="text-centerg-c-primary-dark-color  flex align-items-center  justify-content-between     text-lg font-bold">
            <span>
                {{"initiative_phase_output_review"|translate}}
            </span>
            <span>
                <p-button pTooltip="{{'go_to_project' | translate}}"
                    [routerLink]="['/strategies',strategyId,'projects',projectId]">
                    <span class=" px-5 ">
                        @if(dir=='rtl'){
                        <i class="fa-solid fa-arrow-up-right-from-square fa-flip-horizontal"></i>
                        }@else{
                        <i class="fa-solid fa-arrow-up-right-from-square"></i>
                        }
                    </span>
                </p-button>
            </span>
        </div>
        <div class="flex flex-column align-items-center  gap-3 mt-5">
            <span class="font-bold text-2xl ">
                {{milestone.project_name}}
            </span>
            <span class="font-bold text-xl ">
                {{milestone.name}}
            </span>

        </div>





        <div class="table pt-5 px-5">
            <p-table #table [paginator]=" true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" [class]="dir"
                [value]="milestone.files" dataKey="id" [tableStyle]="{ 'min-width': '80rem' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="text-center">{{'name'|translate}} </th>
                        <th class="text-center"> {{'notes'|translate}} </th>
                        <th class="text-center"> {{'output_status'|translate}} </th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-file>
                    <tr>
                        <td class="text-center">
                            <i class="{{getFileIcon(file.file_type)}}"></i>
                            {{ file.file_name }}
                        </td>
                        <td class="text-center">
                            {{ file.comments }}
                        </td>
                        <td class="text-center">
                            <div class="mr-3">


                                @if(dir=='rtl'){
                                @if(file.status=='approved'){
                                <p-tag severity="success" value="معتمد" />
                                }

                                @if(file.status=='rejected'){
                                <p-tag severity="danger" value="مرفوض" />
                                }

                                @if(file.status=='pending'){
                                <p-tag severity="warning" value="قيد المراجعة" />
                                }

                                }@else{

                                @if(file.status=='approved'){
                                <p-tag severity="success" value="{{file.status}}" />
                                }

                                @if(file.status=='rejected'){
                                <p-tag severity="danger" value="{{file.status}}" />
                                }

                                @if(file.status=='pending'){
                                <p-tag severity="warning" value="{{file.status}}" />
                                }
                                }

                            </div>
                        </td>
                        <td>
                            <div class="cursor-pointer " (click)="openFileViewer(file)">

                                <i class="fa-solid fa-eye fa-xl"></i>
                            </div>
                        </td>
                        <td>
                            <div class="cursor-pointer" (click)="downloadFile(file)">
                                <i class="fa-regular fa-circle-down  fa-xl"></i>
                            </div>
                        </td>
                        <td>
                            <p-button pTooltip="{{'output_assessment'|translate}}" tooltipPosition="right"
                                (onClick)="openAssessmentModal(file)" type="button">
                                <i class="fa-solid fa-list-check"></i>
                            </p-button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-c>
                    <tr>
                        <td class="text-center font-bold text-lg" [attr.colspan]="9">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            {{'no_data_found' | translate}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

@if(assessmentModal)
{
<div class="relative">
    <div class="g-modal ">
        <div class="flex  justify-content-between align-items-center flex-row-reverse ">
            <div (click)="closeAssessmentModal()"
                class=" bg-red-500 cursor-pointe g-c-white  w-3rem p-1 shadow-4 text-center  font-bold text-xl  border-round">
                <i class="fa-solid fa-xmark"></i>
            </div>
            <div class="titel font-bold text-primary-color   g-c-primaryDarkerColor">
                {{'output_assessment'|translate}}
            </div>

        </div>
        <div class="br"></div>
        <div class="modal__body">
            <form #assessmentForm="ngForm" (ngSubmit)="assessOutput()">
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primary-dark font-bold"> {{'the_initiative'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.parentEntityName}}</div>
                    </div>
                </div>
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primary-dark font-bold">{{'milestone'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.subEntityName}}</div>
                    </div>
                </div>
                <div class="mb-3  flex flex-column gap-2">
                    <div class="flex gap-2">
                        <div class="w-2 g-c-primary-dark font-bold">{{'output'|translate}}</div>
                        <span>:</span>
                        <div>{{selectedFile.file_name}}</div>
                    </div>
                </div>



                <div class="mb-3  mt-5 flex flex-column gap-2">
                    <label class="g-c-primary-dark font-bold  "> {{'notes'|translate}}</label>

                    <textarea required name="notes" rows="5" cols="30" pInputTextarea
                        [(ngModel)]="selectedFile.comments"></textarea>

                </div>

                @if (dir=='ltr') {
                <div class="flex flex-wrap gap-3">

                    <label class="font-bold g-c-primaryDarkColor"> {{'output_status'|translate}}</label>
                    <div class="flex align-items-center">
                        <p-radioButton name="{{MediaFileStatusEnum['approved']}}"
                            value="{{MediaFileStatusEnum['approved']}}" [(ngModel)]="selectedFile.status"
                            inputId="approved" />
                        <label for="approved" class="ml-2 text-green-500">
                            {{MediaFileStatusEnum['approved']}}
                        </label>
                    </div>
                    <div class="flex align-items-center">
                        <p-radioButton name="{{MediaFileStatusEnum['rejected']}}"
                            value="{{MediaFileStatusEnum['rejected']}}" [(ngModel)]="selectedFile.status"
                            inputId="rejected" />
                        <label for="rejected" class="ml-2 text-red-500">
                            {{MediaFileStatusEnum['rejected']}}
                        </label>
                    </div>
                </div>
                }@else {
                <div class="flex flex-wrap gap-3">
                    <label class="font-bold g-c-primaryDarkColor"> {{'output_status'|translate}}</label>
                    <div class="flex  gap-2  align-items-center">
                        <p-radioButton name="rejected" value="approved" [(ngModel)]="selectedFile.status"
                            inputId="approved" />
                        <label for="approved" class="ml-2 text-green-500">
                            {{FileStatusValues['approved']}}
                        </label>
                    </div>
                    <div class="flex gap-2 align-items-center">
                        <p-radioButton name="rejected" value="rejected" [(ngModel)]="selectedFile.status"
                            inputId="rejected" />

                        <label for="rejected" class="ml-2 text-red-500">
                            {{FileStatusValues['rejected']}}
                        </label>
                    </div>
                </div>
                }





                <div class="flex  gap-3 mt-7 justify-content-center align-items-center">

                    <div class="text-center">
                        <button [disabled]="assessmentForm.invalid" pButton type=" submit">
                            <div class="flex gap-3">
                                <i class="pi pi-check"></i>
                                <span>{{'assess'|translate}}</span>
                            </div>
                        </button>
                    </div>
                    <div class="text-center">
                        <button pButton class="p-button-danger" (click)="closeAssessmentModal()">
                            <div class="flex gap-3">
                                <i class="pi pi-times"></i>
                                <span>{{'cancel'|translate}}</span>
                            </div>
                        </button>
                    </div>
                </div>


            </form>


        </div>
    </div>
    <div class="g-overlay"></div>
</div>
}

@if(isFileViewer){
<p-dialog header="{{selectedFile?.file_name}}" [modal]="true" [(visible)]="isFileViewer" [style]="{ width: '90rem' }"
    [breakpoints]="{ '1199px': '90vw', '575px': '90vw' }" [maximizable]="true">
    <div>
        <web-viewer [fileUrl]="selectedFile"></web-viewer>
    </div>
</p-dialog>

}